// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InlineEditableField_view__LxBs5 {
  display: block;
  width: 100%;
  min-width: 0;
  padding: 2px 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: inherit;
  text-align: left;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  cursor: text;
}

.InlineEditableField_view__LxBs5:hover,
.InlineEditableField_view__LxBs5:focus-visible {
  background: #eef5ff;
  outline: 2px solid transparent;
}

.InlineEditableField_view__LxBs5:disabled {
  cursor: default;
}

.InlineEditableField_editor__DJmJj {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.InlineEditableField_actions__0whTv {
  display: flex;
  gap: 6px;
  justify-content: flex-start;
}

.InlineEditableField_input__Gp2Rr {
  width: 100%;
  min-height: 32px;
  padding: 4px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  color: #162033;
  font: inherit;
}

.InlineEditableField_input__Gp2Rr:focus {
  border-color: #1677ff;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.12);
}

.InlineEditableField_select__Op9hQ {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Components/InlineEditableField/InlineEditableField.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,qBAAA;EACA,UAAA;EACA,8CAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".view {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  padding: 2px 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  line-height: inherit;\n  text-align: left;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  cursor: text;\n}\n\n.view:hover,\n.view:focus-visible {\n  background: #eef5ff;\n  outline: 2px solid transparent;\n}\n\n.view:disabled {\n  cursor: default;\n}\n\n.editor {\n  display: grid;\n  gap: 8px;\n  min-width: 0;\n}\n\n.actions {\n  display: flex;\n  gap: 6px;\n  justify-content: flex-start;\n}\n\n.input {\n  width: 100%;\n  min-height: 32px;\n  padding: 4px 10px;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  background: #fff;\n  color: #162033;\n  font: inherit;\n}\n\n.input:focus {\n  border-color: #1677ff;\n  outline: 0;\n  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.12);\n}\n\n.select {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `InlineEditableField_view__LxBs5`,
	"editor": `InlineEditableField_editor__DJmJj`,
	"actions": `InlineEditableField_actions__0whTv`,
	"input": `InlineEditableField_input__Gp2Rr`,
	"select": `InlineEditableField_select__Op9hQ`
};
export default ___CSS_LOADER_EXPORT___;
